module.exports = __webpack_public_path__ + "media/images/camera-icon-a182332b2a2977602a1116703183e880.png";